import { Ticket, TicketsService } from '@/@types/generated'

export async function getTicket(id: string): Promise<Ticket> {
  const { ticket } = await TicketsService.getTicket(id)
  return ticket
}
